module.exports = __webpack_public_path__ + "static/media/Gor 2018.11.18-1.fa644ff9.jpg";